
// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableSortLabel,
//   FormHelperText,
//   Stepper,
//   Step,
//   StepLabel,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   LocalBar as MilkIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
//   Agriculture as AgricultureIcon,
//   Receipt as ReceiptIcon,
//   Note as NoteIcon,
//   Person as PersonIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// const MilkProductionPage = () => {
//   const navigate = useNavigate();
//   const [milkingSessions, setMilkingSessions] = useState([]);
//   const [filteredSessions, setFilteredSessions] = useState([]);
//   const [milkingCows, setMilkingCows] = useState([]);
//   const [milkOperators, setMilkOperators] = useState([]); // Changed from employees to milkOperators
//   const [loading, setLoading] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     session_type: "",
//     operator_id: "",
//     start_date: new Date().toISOString().split('T')[0],
//     end_date: new Date().toISOString().split('T')[0]
//   });

//   // Dialogs
//   const [showFilters, setShowFilters] = useState(false);
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [openViewDialog, setOpenViewDialog] = useState(false);
//   const [selectedSession, setSelectedSession] = useState(null);

//   // Form Data
//   const [milkForm, setMilkForm] = useState({
//     animal_id: "",
//     yield_liters: "",
//     session_type: "Morning",
//     quality_score: "",
//     operator_id: "",
//     specific_time: "",
//     notes: "",
//     date_time: new Date().toISOString().split('T')[0]
//   });

//   // Stepper state
//   const [activeStep, setActiveStep] = useState(0);

//   const API_URL = "https://dairy.server.statify.co.ke/api/milking";
//   const ANIMALS_API_URL = "https://dairy.server.statify.co.ke/api/animals";
//   const EMPLOYEES_API_URL = "https://dairy.server.statify.co.ke/api/employees";

//   // Table Columns for Virtualized Table
//   const columns = [
//     { width: 180, label: 'Date & Time', dataKey: 'date_time' },
//     { width: 120, label: 'Cow Tag', dataKey: 'animal_tag' },
//     { width: 120, label: 'Cow Name', dataKey: 'animal_name' },
//     { width: 120, label: 'Session Type', dataKey: 'session_type' },
//     { width: 100, label: 'Yield (L)', dataKey: 'yield_liters' },
//     { width: 100, label: 'Quality', dataKey: 'quality_score' },
//     { width: 150, label: 'Operator', dataKey: 'operator_name' },
//     { width: 200, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Session Type Options
//   const sessionTypes = ["Morning", "Evening", "Regular", "Test"];

//   // Stepper Steps
//   const steps = ['Animal Selection', 'Session Details', 'Review & Submit'];

//   // Milker job titles to filter for
//   const milkerJobTitles = [
//     "Milker",
//     "Senior Milker", 
//     "Junior Milker",
//     "Milking Supervisor",
//     "Milking Technician",
//     "Dairy Farm Manager",
//     "Assistant Dairy Manager",
//     "Chief Dairy Officer"
//   ];

//   // Helper function to format date for display
//   const formatDateTime = (dateString) => {
//     if (!dateString) return "Invalid Date";
    
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) {
//         return "Invalid Date";
//       }
//       return date.toLocaleString();
//     } catch (error) {
//       console.error('Error formatting date:', error);
//       return "Invalid Date";
//     }
//   };

//   // Fetch Milking Cows
//   const fetchMilkingCows = async () => {
//     try {
//       const res = await fetch(`${API_URL}/cows?active_only=true`);
//       if (res.ok) {
//         const data = await res.json();
//         setMilkingCows(data.milking_cows || []);
//       } else {
//         console.error('Failed to fetch milking cows:', res.status);
//         setMilkingCows([]);
//       }
//     } catch (err) {
//       console.error('Error fetching milking cows:', err);
//       setMilkingCows([]);
//     }
//   };

//   // Fetch Milk Operators (only employees with milker job titles)
//   const fetchMilkOperators = async () => {
//     try {
//       const res = await fetch(EMPLOYEES_API_URL);
//       if (res.ok) {
//         const data = await res.json();
//         let employeesList = [];
        
//         if (data.employees && Array.isArray(data.employees)) {
//           employeesList = data.employees;
//         } else if (Array.isArray(data)) {
//           employeesList = data;
//         } else if (data.data && Array.isArray(data.data)) {
//           employeesList = data.data;
//         }
        
//         // Filter only milk operators based on job titles
//         const milkOperatorsList = employeesList.filter(employee => 
//           employee.job_title && 
//           milkerJobTitles.some(title => 
//             employee.job_title.toLowerCase().includes(title.toLowerCase())
//           )
//         );
        
//         console.log('Filtered milk operators:', milkOperatorsList);
//         setMilkOperators(milkOperatorsList);
//       } else {
//         console.error('Failed to fetch employees:', res.status);
//         setMilkOperators([]);
//       }
//     } catch (err) {
//       console.error('Error fetching milk operators:', err);
//       setMilkOperators([]);
//     }
//   };

//   // Fetch Milking Sessions
//   const fetchMilkingSessions = async () => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams();
//       if (filters.session_type) {
//         params.append('session_type', filters.session_type);
//       }
//       if (filters.operator_id) {
//         params.append('operator_id', filters.operator_id);
//       }
//       if (filters.start_date) {
//         params.append('start_date', filters.start_date);
//       }
//       if (filters.end_date) {
//         params.append('end_date', filters.end_date);
//       }

//       const url = `${API_URL}/sessions?${params.toString()}`;
//       const res = await fetch(url);
      
//       if (res.ok) {
//         const data = await res.json();
        
//         // Transform data for display
//         const transformedSessions = (data.sessions || []).map((session) => {
//           // Get cow details
//           let animalTag = `ID: ${session.animal_id}`;
//           let animalName = "Unknown";
          
//           try {
//             const cow = milkingCows.find(c => c.id === session.animal_id);
//             if (cow) {
//               animalTag = cow.tag_number;
//               animalName = cow.name || "Unnamed";
//             }
//           } catch (err) {
//             console.error('Error getting cow details:', err);
//           }

//           // Get operator name - FIXED: Use milkOperators instead of employees
//           let operatorName = "Not specified";
//           if (session.operator_id) {
//             const operator = milkOperators.find(e => e.id === session.operator_id);
//             if (operator) {
//               operatorName = `${operator.first_name || ''} ${operator.last_name || ''}`.trim() || `Operator ${session.operator_id}`;
//             } else {
//               // If operator not found in milk operators, try to get from all employees as fallback
//               console.warn(`Operator ${session.operator_id} not found in milk operators`);
//             }
//           }

//           return {
//             ...session,
//             animal_tag: animalTag,
//             animal_name: animalName,
//             operator_name: operatorName,
//             display_date: formatDateTime(session.date_time)
//           };
//         });
        
//         setMilkingSessions(transformedSessions);
//       } else {
//         console.error('Failed to fetch milking sessions:', res.status);
//         setMilkingSessions([]);
//       }
//     } catch (err) {
//       console.error('Error fetching milking sessions:', err);
//       swal("Error", "Failed to fetch milking sessions", "error");
//       setMilkingSessions([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Initial data fetch
//   useEffect(() => {
//     fetchMilkingCows();
//     fetchMilkOperators(); // Changed from fetchEmployees
//   }, []);

//   // Fetch sessions when dependencies change
//   useEffect(() => {
//     fetchMilkingSessions();
//   }, [filters, milkingCows, milkOperators]); // Added milkOperators as dependency

//   // Filter sessions based on search and filters
//   useEffect(() => {
//     if (!Array.isArray(milkingSessions)) {
//       setFilteredSessions([]);
//       return;
//     }
    
//     let results = milkingSessions;

//     // Apply search term
//     if (searchTerm) {
//       results = results.filter(session =>
//         (session.animal_tag?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (session.animal_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (session.session_type?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (session.operator_name?.toLowerCase() || '').includes(searchTerm.toLowerCase())
//       );
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         const aVal = a[sortConfig.key];
//         const bVal = b[sortConfig.key];
        
//         if (aVal === null || aVal === undefined) return 1;
//         if (bVal === null || bVal === undefined) return -1;
        
//         if (typeof aVal === 'string' && typeof bVal === 'string') {
//           return sortConfig.direction === 'asc' 
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(aVal);
//         }
        
//         if (typeof aVal === 'number' && typeof bVal === 'number') {
//           return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
//         }
        
//         if (aVal < bVal) {
//           return sortConfig.direction === 'asc' ? -1 : 1;
//         }
//         if (aVal > bVal) {
//           return sortConfig.direction === 'asc' ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     setFilteredSessions(results);
//   }, [milkingSessions, searchTerm, sortConfig]);

//   // Sort Handler
//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Filter Handlers
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       session_type: "",
//       operator_id: "",
//       start_date: new Date().toISOString().split('T')[0],
//       end_date: new Date().toISOString().split('T')[0]
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   };

//   // Form Handlers
//   const handleFormChange = (field, value) => {
//     setMilkForm(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const resetForm = () => {
//     setMilkForm({
//       animal_id: "",
//       yield_liters: "",
//       session_type: "Morning",
//       quality_score: "",
//       operator_id: "",
//       specific_time: "",
//       notes: "",
//       date_time: new Date().toISOString().split('T')[0]
//     });
//     setActiveStep(0);
//   };

//   // Stepper Handlers
//   const handleNext = () => {
//     setActiveStep((prevStep) => prevStep + 1);
//   };

//   const handleBack = () => {
//     setActiveStep((prevStep) => prevStep - 1);
//   };

//   // Create Milking Session
//   const handleCreateMilkingSession = async () => {
//     // Validation
//     if (!milkForm.animal_id || !milkForm.yield_liters) {
//       swal("Error", "Animal and milk yield are required", "error");
//       return;
//     }

//     if (parseFloat(milkForm.yield_liters) <= 0) {
//       swal("Error", "Milk yield must be greater than 0", "error");
//       return;
//     }

//     try {
//       const sessionData = {
//         animal_id: parseInt(milkForm.animal_id),
//         yield_liters: parseFloat(milkForm.yield_liters),
//         session_type: milkForm.session_type,
//         quality_score: milkForm.quality_score ? parseFloat(milkForm.quality_score) : null,
//         specific_time: milkForm.specific_time || null,
//         notes: milkForm.notes || "",
//         date_time: milkForm.date_time,
//       };

//       // Only add operator_id if it exists and is a valid milk operator
//       if (milkForm.operator_id && parseInt(milkForm.operator_id) > 0) {
//         const operatorExists = milkOperators.find(operator => operator.id === parseInt(milkForm.operator_id));
//         if (operatorExists) {
//           sessionData.operator_id = parseInt(milkForm.operator_id);
//         } else {
//           console.warn('Operator ID not found in milk operators list, setting to null');
//         }
//       }

//       console.log('Sending session data:', sessionData);

//       const res = await fetch(`${API_URL}/sessions`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(sessionData),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Milking session recorded successfully!", "success");
//         setOpenCreateDialog(false);
//         resetForm();
//         fetchMilkingSessions();
//       } else {
//         console.error('Server error:', data);
//         swal("Error", data.error || "Failed to record session", "error");
//       }
//     } catch (err) {
//       console.error('Error creating session:', err);
//       swal("Error", "Something went wrong while recording the session", "error");
//     }
//   };

//   // Update Milking Session
//   const handleUpdateMilkingSession = async () => {
//     if (!selectedSession) return;

//     try {
//       const sessionData = {
//         animal_id: parseInt(milkForm.animal_id),
//         yield_liters: parseFloat(milkForm.yield_liters),
//         session_type: milkForm.session_type,
//         quality_score: milkForm.quality_score ? parseFloat(milkForm.quality_score) : null,
//         specific_time: milkForm.specific_time || null,
//         notes: milkForm.notes || "",
//         date_time: milkForm.date_time,
//       };

//       // Only add operator_id if it exists and is a valid milk operator
//       if (milkForm.operator_id && parseInt(milkForm.operator_id) > 0) {
//         const operatorExists = milkOperators.find(operator => operator.id === parseInt(milkForm.operator_id));
//         if (operatorExists) {
//           sessionData.operator_id = parseInt(milkForm.operator_id);
//         } else {
//           console.warn('Operator ID not found in milk operators list, setting to null');
//         }
//       }

//       console.log('Updating session data:', sessionData);

//       const res = await fetch(`${API_URL}/sessions/${selectedSession.id}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(sessionData),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Milking session updated successfully!", "success");
//         setOpenEditDialog(false);
//         setSelectedSession(null);
//         resetForm();
//         fetchMilkingSessions();
//       } else {
//         console.error('Server error:', data);
//         swal("Error", data.error || "Failed to update session", "error");
//       }
//     } catch (err) {
//       console.error('Error updating session:', err);
//       swal("Error", "Something went wrong while updating the session", "error");
//     }
//   };

//   // Delete Handler
//   const handleDelete = async (sessionId) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the milking session!",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/sessions/${sessionId}`, { method: "DELETE" });
//         const data = await res.json();
//         if (res.ok) {
//           swal("Deleted!", data.message, "success");
//           fetchMilkingSessions();
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // View Handler
//   const handleView = (session) => {
//     setSelectedSession(session);
//     setOpenViewDialog(true);
//   };

//   // Edit Handler
//   const handleEdit = (session) => {
//     setSelectedSession(session);
//     setMilkForm({
//       animal_id: session.animal_id.toString(),
//       yield_liters: session.yield_liters.toString(),
//       session_type: session.session_type,
//       quality_score: session.quality_score ? session.quality_score.toString() : "",
//       operator_id: session.operator_id ? session.operator_id.toString() : "",
//       specific_time: session.specific_time || "",
//       notes: session.notes || "",
//       date_time: session.date_time.split('T')[0]
//     });
//     setOpenEditDialog(true);
//   };

//   // Generate Receipt
//   const generateReceipt = (session) => {
//     const receiptWindow = window.open("", "_blank");
//     const receiptContent = `
//       <html>
//         <head>
//           <title>Milk Production Receipt</title>
//           <style>
//             body { font-family: Arial, sans-serif; margin: 20px; }
//             .header { text-align: center; border-bottom: 2px solid #1976d2; padding-bottom: 10px; }
//             .details { margin: 20px 0; }
//             .detail-row { display: flex; justify-content: space-between; margin: 5px 0; }
//             .footer { margin-top: 30px; text-align: center; font-size: 12px; color: #666; }
//             .notes { margin-top: 15px; padding: 10px; background: #f5f5f5; border-radius: 5px; }
//           </style>
//         </head>
//         <body>
//           <div class="header">
//             <h1 style="color: #1976d2;">🥛 Milk Production Receipt</h1>
//             <p>Generated on: ${new Date().toLocaleDateString()}</p>
//           </div>
//           <div class="details">
//             <div class="detail-row"><strong>Animal Tag:</strong> ${session.animal_tag}</div>
//             <div class="detail-row"><strong>Animal Name:</strong> ${session.animal_name}</div>
//             <div class="detail-row"><strong>Session Type:</strong> ${session.session_type}</div>
//             <div class="detail-row"><strong>Milk Yield:</strong> ${session.yield_liters} Liters</div>
//             <div class="detail-row"><strong>Quality Score:</strong> ${session.quality_score || 'N/A'}</div>
//             <div class="detail-row"><strong>Operator:</strong> ${session.operator_name}</div>
//             <div class="detail-row"><strong>Date & Time:</strong> ${session.display_date}</div>
//             ${session.notes ? `
//               <div class="notes">
//                 <strong>Notes:</strong><br>${session.notes}
//               </div>
//             ` : ''}
//           </div>
//           <div class="footer">
//             <p>Generated on ${new Date().toLocaleString()}</p>
//           </div>
//         </body>
//       </html>
//     `;
    
//     receiptWindow.document.write(receiptContent);
//     receiptWindow.document.close();
//     receiptWindow.print();
//   };

//   // Get Session Type Color
//   const getSessionTypeColor = (sessionType) => {
//     switch (sessionType) {
//       case "Morning": return 'primary';
//       case "Evening": return 'secondary';
//       case "Regular": return 'success';
//       case "Test": return 'warning';
//       default: return 'default';
//     }
//   };

//   // Get Quality Score Color
//   const getQualityColor = (score) => {
//     if (!score) return 'default';
//     if (score >= 4.0) return 'success';
//     if (score >= 3.0) return 'warning';
//     return 'error';
//   };

//   // Virtualized Table Content
//   const fixedHeaderContent = () => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: 'info.main', 
//             color: 'white',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           <TableSortLabel
//             active={sortConfig.key === column.dataKey}
//             direction={sortConfig.direction}
//             onClick={() => handleSort(column.dataKey)}
//             sx={{ color: 'white !important' }}
//           >
//             {column.label}
//           </TableSortLabel>
//         </TableCell>
//       ))}
//     </TableRow>
//   );

//   const rowContent = (index, session) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {session.display_date}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {session.animal_tag}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {session.animal_name}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={session.session_type} 
//           size="small"
//           color={getSessionTypeColor(session.session_type)}
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" color="primary" noWrap>
//           {session.yield_liters} L
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         {session.quality_score ? (
//           <Chip 
//             label={session.quality_score} 
//             size="small"
//             color={getQualityColor(session.quality_score)}
//             sx={{ fontSize: '0.7rem', height: '24px' }}
//           />
//         ) : (
//           <Typography variant="body2" color="textSecondary" noWrap>
//             N/A
//           </Typography>
//         )}
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap title={session.operator_name}>
//           {session.operator_name}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             color="info"
//             onClick={() => handleView(session)}
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               backgroundColor: 'info.light',
//               '&:hover': { backgroundColor: 'info.main' }
//             }}
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="primary"
//             onClick={() => handleEdit(session)}
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               backgroundColor: 'primary.light',
//               '&:hover': { backgroundColor: 'primary.main' }
//             }}
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="success"
//             onClick={() => generateReceipt(session)}
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               backgroundColor: 'success.light',
//               '&:hover': { backgroundColor: 'success.main' }
//             }}
//           >
//             <ReceiptIcon fontSize="small" />
//           </IconButton>
//           {session.notes && (
//             <IconButton 
//               size="small" 
//               color="warning"
//               onClick={() => swal("Session Notes", session.notes || "No notes available", "info")}
//               sx={{ 
//                 minWidth: '32px', 
//                 width: '32px', 
//                 height: '32px',
//                 backgroundColor: 'warning.light',
//                 '&:hover': { backgroundColor: 'warning.main' }
//               }}
//             >
//               <NoteIcon fontSize="small" />
//             </IconButton>
//           )}
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(session.id)}
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               backgroundColor: 'error.light',
//               '&:hover': { backgroundColor: 'error.main' }
//             }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   );

//   // Stepper Content
//   const getStepContent = (step) => {
//     switch (step) {
//       case 0:
//         return (
//           <Box>
//             <Typography variant="h6" gutterBottom color="primary">
//               Select Animal
//             </Typography>
//             <FormControl fullWidth size="large" sx={{ mb: 3 }}>
//               <InputLabel id="animal-label">Select Animal *</InputLabel>
//               <Select
//                 labelId="animal-label"
//                 value={milkForm.animal_id}
//                 onChange={(e) => handleFormChange('animal_id', e.target.value)}
//                 label="Select Animal *"
//                 disabled={milkingCows.length === 0}
//               >
//                 {milkingCows.map(cow => (
//                   <MenuItem key={cow.id} value={cow.id.toString()}>
//                     <Box>
//                       <Typography variant="body1" fontWeight="bold">
//                         {cow.tag_number} - {cow.name || 'Unnamed'}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary">
//                         {cow.breed} • ID: {cow.id}
//                       </Typography>
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//               <FormHelperText>
//                 Choose the cow that was milked (required)
//               </FormHelperText>
//             </FormControl>
//           </Box>
//         );
      
//       case 1:
//         return (
//           <Box>
//             <Typography variant="h6" gutterBottom color="primary">
//               Session Details
//             </Typography>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   size="large"
//                   label="Milk Yield (Liters) *"
//                   type="number"
//                   step="0.1"
//                   value={milkForm.yield_liters}
//                   onChange={(e) => handleFormChange('yield_liters', e.target.value)}
//                   placeholder="Enter amount in liters"
//                   required
//                   sx={{ mb: 3 }}
//                   helperText="Total milk collected in liters (required)"
//                 />

//                 <FormControl fullWidth size="large" sx={{ mb: 3 }}>
//                   <InputLabel id="session-type-label">Session Type</InputLabel>
//                   <Select
//                     labelId="session-type-label"
//                     value={milkForm.session_type}
//                     onChange={(e) => handleFormChange('session_type', e.target.value)}
//                     label="Session Type"
//                   >
//                     {sessionTypes.map(type => (
//                       <MenuItem key={type} value={type}>
//                         {type} Session
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   <FormHelperText>
//                     Type of milking session
//                   </FormHelperText>
//                 </FormControl>

//                 <TextField
//                   fullWidth
//                   size="large"
//                   label="Quality Score (Butterfat %)"
//                   type="number"
//                   step="0.1"
//                   value={milkForm.quality_score}
//                   onChange={(e) => handleFormChange('quality_score', e.target.value)}
//                   placeholder="Optional butterfat percentage"
//                   sx={{ mb: 3 }}
//                   helperText="Milk quality measurement (optional)"
//                 />
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <FormControl fullWidth size="large" sx={{ mb: 3 }}>
//                   <InputLabel id="operator-label">Select Operator</InputLabel>
//                   <Select
//                     labelId="operator-label"
//                     value={milkForm.operator_id}
//                     onChange={(e) => handleFormChange('operator_id', e.target.value)}
//                     label="Select Operator"
//                   >
//                     <MenuItem value="">
//                       <em>Not specified</em>
//                     </MenuItem>
//                     {milkOperators.map(operator => (
//                       <MenuItem key={operator.id} value={operator.id.toString()}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <PersonIcon fontSize="small" />
//                           <Box>
//                             <Typography variant="body1">
//                               {operator.first_name} {operator.last_name}
//                             </Typography>
//                             <Typography variant="body2" color="textSecondary">
//                               {operator.job_title || 'Milker'} • ID: {operator.id}
//                             </Typography>
//                           </Box>
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   <FormHelperText>
//                     {milkOperators.length === 0 ? 
//                       "No milk operators found. Please add employees with milker roles first." : 
//                       "Person who performed the milking (optional)"
//                     }
//                   </FormHelperText>
//                 </FormControl>

//                 <TextField
//                   fullWidth
//                   size="large"
//                   label="Specific Time"
//                   type="time"
//                   value={milkForm.specific_time}
//                   onChange={(e) => handleFormChange('specific_time', e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   sx={{ mb: 3 }}
//                   helperText="Time when milking occurred"
//                 />

//                 <TextField
//                   fullWidth
//                   size="large"
//                   label="Session Date"
//                   type="date"
//                   value={milkForm.date_time}
//                   onChange={(e) => handleFormChange('date_time', e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   sx={{ mb: 3 }}
//                   helperText="Date when milking occurred"
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//         );
      
//       case 2:
//         return (
//           <Box>
//             <Typography variant="h6" gutterBottom color="primary">
//               Review & Notes
//             </Typography>
//             <Card variant="outlined" sx={{ mb: 3, p: 2 }}>
//               <Typography variant="subtitle1" gutterBottom>
//                 Session Summary
//               </Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">Animal:</Typography>
//                   <Typography variant="body1" fontWeight="bold">
//                     {milkingCows.find(c => c.id === parseInt(milkForm.animal_id))?.tag_number || 'Not selected'}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">Yield:</Typography>
//                   <Typography variant="body1" fontWeight="bold" color="primary">
//                     {milkForm.yield_liters} Liters
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">Session Type:</Typography>
//                   <Chip 
//                     label={milkForm.session_type} 
//                     size="small"
//                     color={getSessionTypeColor(milkForm.session_type)}
//                   />
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">Operator:</Typography>
//                   <Typography variant="body1">
//                     {milkOperators.find(o => o.id === parseInt(milkForm.operator_id)) ? 
//                       `${milkOperators.find(o => o.id === parseInt(milkForm.operator_id)).first_name} ${milkOperators.find(o => o.id === parseInt(milkForm.operator_id)).last_name}` : 
//                       'Not specified'
//                     }
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Card>

//             <TextField
//               fullWidth
//               multiline
//               rows={4}
//               label="Session Notes"
//               placeholder="Add any observations, comments, or special notes about this milking session..."
//               value={milkForm.notes}
//               onChange={(e) => handleFormChange('notes', e.target.value)}
//               helperText="Optional notes about the milking session"
//             />
//           </Box>
//         );
      
//       default:
//         return 'Unknown step';
//     }
//   };

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'info.dark' }}>
//         <Toolbar>
//           <MilkIcon sx={{ mr: 2 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Milk Production
//           </Typography>
//           <Chip 
//             label={`${milkingSessions.length} Sessions`} 
//             color="secondary" 
//             variant="filled"
//             sx={{ color: 'white', fontWeight: 'bold', mr: 2 }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon />}
//             onClick={() => setOpenCreateDialog(true)}
//             sx={{ 
//               borderRadius: 2, 
//               backgroundColor: 'success.main',
//               '&:hover': {
//                 backgroundColor: 'success.dark',
//                 transform: 'translateY(-2px)',
//                 boxShadow: 4
//               },
//               transition: 'all 0.3s ease',
//               fontWeight: 'bold',
//               fontSize: '1rem',
//               px: 3,
//               py: 1
//             }}
//           >
//             New Session
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ borderRadius: 2, border: 2, borderColor: 'info.light', overflow: 'hidden' }}>
//           {/* Search and Filters Header */}
//           <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider', backgroundColor: 'background.paper' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search by cow tag, name, session type, operator..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
//                   }}
//                   size="medium"
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: 2,
//                     }
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="medium"
//                     color="info"
//                     sx={{ borderRadius: 2 }}
//                   >
//                     Filters
//                   </Button>
//                   <Button 
//                     onClick={resetFilters} 
//                     variant="outlined" 
//                     size="medium" 
//                     color="info"
//                     sx={{ borderRadius: 2 }}
//                   >
//                     Reset
//                   </Button>
//                   <Button 
//                     onClick={fetchMilkingSessions} 
//                     variant="contained" 
//                     size="medium" 
//                     color="primary"
//                     sx={{ borderRadius: 2 }}
//                   >
//                     Refresh
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={3}>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="medium">
//                       <InputLabel>Session Type</InputLabel>
//                       <Select
//                         value={filters.session_type}
//                         onChange={(e) => handleFilterChange('session_type', e.target.value)}
//                         label="Session Type"
//                       >
//                         <MenuItem value="">All Types</MenuItem>
//                         {sessionTypes.map(type => (
//                           <MenuItem key={type} value={type}>{type}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="medium">
//                       <InputLabel>Operator</InputLabel>
//                       <Select
//                         value={filters.operator_id}
//                         onChange={(e) => handleFilterChange('operator_id', e.target.value)}
//                         label="Operator"
//                       >
//                         <MenuItem value="">All Operators</MenuItem>
//                         {milkOperators.map(operator => (
//                           <MenuItem key={operator.id} value={operator.id.toString()}>
//                             {operator.first_name} {operator.last_name}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <TextField
//                       fullWidth
//                       size="medium"
//                       label="Start Date"
//                       type="date"
//                       value={filters.start_date}
//                       onChange={(e) => handleFilterChange('start_date', e.target.value)}
//                       InputLabelProps={{ shrink: true }}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <TextField
//                       fullWidth
//                       size="medium"
//                       label="End Date"
//                       type="date"
//                       value={filters.end_date}
//                       onChange={(e) => handleFilterChange('end_date', e.target.value)}
//                       InputLabelProps={{ shrink: true }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Sessions Table */}
//           <Box sx={{ p: 2 }}>
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress color="info" />
//               </Box>
//             ) : filteredSessions.length === 0 ? (
//               <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: 'info.light' }}>
//                 <CardContent>
//                   <AgricultureIcon sx={{ fontSize: 64, color: 'info.main', mb: 2 }} />
//                   <Typography variant="h5" color="info.main" gutterBottom>
//                     No milking sessions found
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     {searchTerm || Object.values(filters).some(v => v) 
//                       ? "Try adjusting your search or filters" 
//                       : "Record your first milking session to track milk production"
//                     }
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     color="info" 
//                     onClick={() => setOpenCreateDialog(true)} 
//                     size="large"
//                     startIcon={<AddIcon />}
//                     sx={{ borderRadius: 2 }}
//                   >
//                     Record First Session
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: 'info.light', borderRadius: 1 }}>
//                 <TableVirtuoso
//                   data={filteredSessions}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Create Milking Session Dialog with Stepper */}
//       <Dialog 
//         open={openCreateDialog} 
//         onClose={() => {
//           setOpenCreateDialog(false);
//           resetForm();
//         }}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ backgroundColor: 'primary.main', color: 'white' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <AddIcon sx={{ mr: 1 }} />
//               <Typography variant="h6">Record New Milking Session</Typography>
//             </Box>
//             <IconButton 
//               onClick={() => {
//                 setOpenCreateDialog(false);
//                 resetForm();
//               }} 
//               sx={{ color: 'white' }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>

//         <DialogContent sx={{ p: 4 }}>
//           {/* Stepper */}
//           <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
//             {steps.map((label) => (
//               <Step key={label}>
//                 <StepLabel>{label}</StepLabel>
//               </Step>
//             ))}
//           </Stepper>

//           {/* Step Content */}
//           {getStepContent(activeStep)}

//           {milkingCows.length === 0 && (
//             <Alert severity="warning" sx={{ mt: 2 }}>
//               No cows available for milking. Please add animals first.
//             </Alert>
//           )}

//           {milkOperators.length === 0 && (
//             <Alert severity="info" sx={{ mt: 2 }}>
//               No milk operators found. Please add employees with milker roles to assign operators.
//             </Alert>
//           )}
//         </DialogContent>

//         <DialogActions sx={{ p: 3, justifyContent: 'space-between' }}>
//           <Button 
//             onClick={handleBack} 
//             disabled={activeStep === 0}
//             sx={{ minWidth: 100 }}
//           >
//             Back
//           </Button>
          
//           <Box sx={{ display: 'flex', gap: 2 }}>
//             <Button 
//               onClick={() => {
//                 setOpenCreateDialog(false);
//                 resetForm();
//               }} 
//               sx={{ minWidth: 100 }}
//             >
//               Cancel
//             </Button>
            
//             {activeStep === steps.length - 1 ? (
//               <Button 
//                 onClick={handleCreateMilkingSession} 
//                 variant="contained" 
//                 color="success"
//                 disabled={!milkForm.animal_id || !milkForm.yield_liters}
//                 sx={{ minWidth: 150 }}
//               >
//                 Record Session
//               </Button>
//             ) : (
//               <Button 
//                 onClick={handleNext} 
//                 variant="contained"
//                 disabled={activeStep === 0 && !milkForm.animal_id}
//                 sx={{ minWidth: 100 }}
//               >
//                 Next
//               </Button>
//             )}
//           </Box>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Milking Session Dialog */}
//       <Dialog 
//         open={openEditDialog} 
//         onClose={() => setOpenEditDialog(false)}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ backgroundColor: 'primary.main', color: 'white' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <EditIcon sx={{ mr: 1 }} />
//             <Typography variant="h6">Edit Milking Session</Typography>
//           </Box>
//         </DialogTitle>
//         <DialogContent sx={{ p: 4 }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={6}>
//               <FormControl fullWidth size="large" sx={{ mb: 3 }}>
//                 <InputLabel id="edit-animal-label">Select Animal *</InputLabel>
//                 <Select
//                   labelId="edit-animal-label"
//                   value={milkForm.animal_id}
//                   onChange={(e) => handleFormChange('animal_id', e.target.value)}
//                   label="Select Animal *"
//                 >
//                   {milkingCows.map(cow => (
//                     <MenuItem key={cow.id} value={cow.id.toString()}>
//                       <Box>
//                         <Typography variant="body1" fontWeight="bold">
//                           {cow.tag_number} - {cow.name || 'Unnamed'}
//                         </Typography>
//                         <Typography variant="body2" color="textSecondary">
//                           {cow.breed} • ID: {cow.id}
//                         </Typography>
//                       </Box>
//                     </MenuItem>
//                   ))}
//                 </Select>
//                 <FormHelperText>
//                   Choose the cow that was milked (required)
//                 </FormHelperText>
//               </FormControl>

//               <FormControl fullWidth size="large" sx={{ mb: 3 }}>
//                 <InputLabel id="edit-operator-label">Select Operator</InputLabel>
//                 <Select
//                   labelId="edit-operator-label"
//                   value={milkForm.operator_id}
//                   onChange={(e) => handleFormChange('operator_id', e.target.value)}
//                   label="Select Operator"
//                 >
//                   <MenuItem value="">
//                     <em>Not specified</em>
//                   </MenuItem>
//                   {milkOperators.map(operator => (
//                     <MenuItem key={operator.id} value={operator.id.toString()}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <PersonIcon fontSize="small" />
//                         <Box>
//                           <Typography variant="body1">
//                             {operator.first_name} {operator.last_name}
//                           </Typography>
//                           <Typography variant="body2" color="textSecondary">
//                             {operator.job_title || 'Milker'} • ID: {operator.id}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </MenuItem>
//                   ))}
//                 </Select>
//                 <FormHelperText>
//                   Person who performed the milking (optional)
//                 </FormHelperText>
//               </FormControl>

//               <FormControl fullWidth size="large" sx={{ mb: 3 }}>
//                 <InputLabel id="edit-session-type-label">Session Type</InputLabel>
//                 <Select
//                   labelId="edit-session-type-label"
//                   value={milkForm.session_type}
//                   onChange={(e) => handleFormChange('session_type', e.target.value)}
//                   label="Session Type"
//                 >
//                   {sessionTypes.map(type => (
//                     <MenuItem key={type} value={type}>
//                       {type} Session
//                     </MenuItem>
//                   ))}
//                 </Select>
//                 <FormHelperText>
//                   Type of milking session
//                 </FormHelperText>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 size="large"
//                 label="Milk Yield (Liters) *"
//                 type="number"
//                 step="0.1"
//                 value={milkForm.yield_liters}
//                 onChange={(e) => handleFormChange('yield_liters', e.target.value)}
//                 placeholder="Enter amount in liters"
//                 required
//                 sx={{ mb: 3 }}
//                 helperText="Total milk collected in liters (required)"
//               />

//               <TextField
//                 fullWidth
//                 size="large"
//                 label="Quality Score (Butterfat %)"
//                 type="number"
//                 step="0.1"
//                 value={milkForm.quality_score}
//                 onChange={(e) => handleFormChange('quality_score', e.target.value)}
//                 placeholder="Optional butterfat percentage"
//                 sx={{ mb: 3 }}
//                 helperText="Milk quality measurement (optional)"
//               />

//               <TextField
//                 fullWidth
//                 size="large"
//                 label="Specific Time"
//                 type="time"
//                 value={milkForm.specific_time}
//                 onChange={(e) => handleFormChange('specific_time', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 sx={{ mb: 3 }}
//                 helperText="Time when milking occurred"
//               />

//               <TextField
//                 fullWidth
//                 size="large"
//                 label="Session Date"
//                 type="date"
//                 value={milkForm.date_time}
//                 onChange={(e) => handleFormChange('date_time', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 sx={{ mb: 3 }}
//                 helperText="Date when milking occurred"
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={4}
//                 label="Session Notes"
//                 placeholder="Add any observations, comments, or special notes about this milking session..."
//                 value={milkForm.notes}
//                 onChange={(e) => handleFormChange('notes', e.target.value)}
//                 helperText="Optional notes about the milking session"
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions sx={{ p: 3 }}>
//           <Button 
//             onClick={() => setOpenEditDialog(false)} 
//             size="large"
//             sx={{ minWidth: 120 }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleUpdateMilkingSession} 
//             variant="contained" 
//             color="primary"
//             size="large"
//             disabled={!milkForm.animal_id || !milkForm.yield_liters}
//             sx={{ minWidth: 200 }}
//           >
//             Update Session
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* View Session Dialog */}
//       <Dialog 
//         open={openViewDialog} 
//         onClose={() => setOpenViewDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <ViewIcon sx={{ mr: 1 }} />
//               Milking Session Details
//             </Box>
//             <IconButton onClick={() => setOpenViewDialog(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedSession && (
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Animal Information
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Animal Tag:</strong> {selectedSession.animal_tag}
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Animal Name:</strong> {selectedSession.animal_name}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
              
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Session Details
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Date & Time:</strong> {selectedSession.display_date}
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Session Type:</strong> 
//                       <Chip 
//                         label={selectedSession.session_type} 
//                         size="small"
//                         color={getSessionTypeColor(selectedSession.session_type)}
//                         sx={{ ml: 1 }}
//                       />
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Production Data
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Milk Yield:</strong> {selectedSession.yield_liters} Liters
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Quality Score:</strong> 
//                       {selectedSession.quality_score ? (
//                         <Chip 
//                           label={selectedSession.quality_score} 
//                           size="small"
//                           color={getQualityColor(selectedSession.quality_score)}
//                           sx={{ ml: 1 }}
//                         />
//                       ) : 'N/A'}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Operator Information
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Operator:</strong> {selectedSession.operator_name}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {selectedSession.notes && (
//                 <Grid item xs={12}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <Typography variant="h6" gutterBottom color="primary">
//                         Session Notes
//                       </Typography>
//                       <Typography variant="body2">
//                         {selectedSession.notes}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               )}
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
//           <Button 
//             onClick={() => generateReceipt(selectedSession)} 
//             variant="contained" 
//             color="primary"
//             startIcon={<ReceiptIcon />}
//           >
//             Generate Receipt
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default MilkProductionPage;


import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
  Card,
  CardContent,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  FormHelperText,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Close as CloseIcon,
  LocalBar as MilkIcon,
  FilterList as FilterIcon,
  Search as SearchIcon,
  Agriculture as AgricultureIcon,
  Receipt as ReceiptIcon,
  Note as NoteIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import { TableVirtuoso } from "react-virtuoso";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// Color constants
const PRIMARY_COLOR = '#024A59';
const SECONDARY_COLOR = '#FFA916';
const PRIMARY_LIGHT = '#346875';
const PRIMARY_DARK = '#013440';

// Virtualized Table Components
const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow: (props) => <TableRow {...props} />,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

const MilkProductionPage = () => {
  const navigate = useNavigate();
  const [milkingSessions, setMilkingSessions] = useState([]);
  const [filteredSessions, setFilteredSessions] = useState([]);
  const [milkingCows, setMilkingCows] = useState([]);
  const [milkOperators, setMilkOperators] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Filters and Search
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filters, setFilters] = useState({
    session_type: "",
    operator_id: "",
    start_date: new Date().toISOString().split('T')[0],
    end_date: new Date().toISOString().split('T')[0]
  });

  // Dialogs
  const [showFilters, setShowFilters] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);

  // Form Data
  const [milkForm, setMilkForm] = useState({
    animal_id: "",
    yield_liters: "",
    session_type: "Morning",
    quality_score: "",
    operator_id: "",
    specific_time: "",
    notes: "",
    date_time: new Date().toISOString().split('T')[0]
  });

  // Stepper state
  const [activeStep, setActiveStep] = useState(0);

  const API_URL = "https://dairy.server.statify.co.ke/api/milking";
  const ANIMALS_API_URL = "https://dairy.server.statify.co.ke/api/animals";
  const EMPLOYEES_API_URL = "https://dairy.server.statify.co.ke/api/employees";

  // Table Columns for Virtualized Table
  const columns = [
    { width: 180, label: 'Date & Time', dataKey: 'date_time' },
    { width: 120, label: 'Cow Tag', dataKey: 'animal_tag' },
    { width: 120, label: 'Cow Name', dataKey: 'animal_name' },
    { width: 120, label: 'Session Type', dataKey: 'session_type' },
    { width: 100, label: 'Yield (L)', dataKey: 'yield_liters' },
    { width: 100, label: 'Quality', dataKey: 'quality_score' },
    { width: 150, label: 'Operator', dataKey: 'operator_name' },
    { width: 200, label: 'Actions', dataKey: 'actions' },
  ];

  // Session Type Options
  const sessionTypes = ["Morning", "Evening", "Regular", "Test"];

  // Stepper Steps
  const steps = ['Animal Selection', 'Session Details', 'Review & Submit'];

  // Milker job titles to filter for
  const milkerJobTitles = [
    "Milker",
    "Senior Milker", 
    "Junior Milker",
    "Milking Supervisor",
    "Milking Technician",
    "Dairy Farm Manager",
    "Assistant Dairy Manager",
    "Chief Dairy Officer"
  ];

  // Helper function to format date for display
  const formatDateTime = (dateString) => {
    if (!dateString) return "Invalid Date";
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return "Invalid Date";
      }
      return date.toLocaleString();
    } catch (error) {
      console.error('Error formatting date:', error);
      return "Invalid Date";
    }
  };

  // Fetch Milking Cows
  const fetchMilkingCows = async () => {
    try {
      const res = await fetch(`${API_URL}/cows?active_only=true`);
      if (res.ok) {
        const data = await res.json();
        setMilkingCows(data.milking_cows || []);
      } else {
        console.error('Failed to fetch milking cows:', res.status);
        setMilkingCows([]);
      }
    } catch (err) {
      console.error('Error fetching milking cows:', err);
      setMilkingCows([]);
    }
  };

  // Fetch Milk Operators (only employees with milker job titles)
  const fetchMilkOperators = async () => {
    try {
      const res = await fetch(EMPLOYEES_API_URL);
      if (res.ok) {
        const data = await res.json();
        let employeesList = [];
        
        if (data.employees && Array.isArray(data.employees)) {
          employeesList = data.employees;
        } else if (Array.isArray(data)) {
          employeesList = data;
        } else if (data.data && Array.isArray(data.data)) {
          employeesList = data.data;
        }
        
        // Filter only milk operators based on job titles
        const milkOperatorsList = employeesList.filter(employee => 
          employee.job_title && 
          milkerJobTitles.some(title => 
            employee.job_title.toLowerCase().includes(title.toLowerCase())
          )
        );
        
        console.log('Filtered milk operators:', milkOperatorsList);
        setMilkOperators(milkOperatorsList);
      } else {
        console.error('Failed to fetch employees:', res.status);
        setMilkOperators([]);
      }
    } catch (err) {
      console.error('Error fetching milk operators:', err);
      setMilkOperators([]);
    }
  };

  // Fetch Milking Sessions
  const fetchMilkingSessions = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.session_type) {
        params.append('session_type', filters.session_type);
      }
      if (filters.operator_id) {
        params.append('operator_id', filters.operator_id);
      }
      if (filters.start_date) {
        params.append('start_date', filters.start_date);
      }
      if (filters.end_date) {
        params.append('end_date', filters.end_date);
      }

      const url = `${API_URL}/sessions?${params.toString()}`;
      const res = await fetch(url);
      
      if (res.ok) {
        const data = await res.json();
        
        // Transform data for display
        const transformedSessions = (data.sessions || []).map((session) => {
          // Get cow details
          let animalTag = `ID: ${session.animal_id}`;
          let animalName = "Unknown";
          
          try {
            const cow = milkingCows.find(c => c.id === session.animal_id);
            if (cow) {
              animalTag = cow.tag_number;
              animalName = cow.name || "Unnamed";
            }
          } catch (err) {
            console.error('Error getting cow details:', err);
          }

          // Get operator name
          let operatorName = "Not specified";
          if (session.operator_id) {
            const operator = milkOperators.find(e => e.id === session.operator_id);
            if (operator) {
              operatorName = `${operator.first_name || ''} ${operator.last_name || ''}`.trim() || `Operator ${session.operator_id}`;
            } else {
              console.warn(`Operator ${session.operator_id} not found in milk operators`);
            }
          }

          return {
            ...session,
            animal_tag: animalTag,
            animal_name: animalName,
            operator_name: operatorName,
            display_date: formatDateTime(session.date_time)
          };
        });
        
        setMilkingSessions(transformedSessions);
      } else {
        console.error('Failed to fetch milking sessions:', res.status);
        setMilkingSessions([]);
      }
    } catch (err) {
      console.error('Error fetching milking sessions:', err);
      swal("Error", "Failed to fetch milking sessions", "error");
      setMilkingSessions([]);
    } finally {
      setLoading(false);
    }
  };

  // Initial data fetch
  useEffect(() => {
    fetchMilkingCows();
    fetchMilkOperators();
  }, []);

  // Fetch sessions when dependencies change
  useEffect(() => {
    fetchMilkingSessions();
  }, [filters, milkingCows, milkOperators]);

  // Filter sessions based on search and filters
  useEffect(() => {
    if (!Array.isArray(milkingSessions)) {
      setFilteredSessions([]);
      return;
    }
    
    let results = milkingSessions;

    // Apply search term
    if (searchTerm) {
      results = results.filter(session =>
        (session.animal_tag?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (session.animal_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (session.session_type?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (session.operator_name?.toLowerCase() || '').includes(searchTerm.toLowerCase())
      );
    }

    // Apply sorting
    if (sortConfig.key) {
      results.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
        
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
        
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return sortConfig.direction === 'asc' 
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }
        
        if (typeof aVal === 'number' && typeof bVal === 'number') {
          return sortConfig.direction === 'asc' ? aVal - bVal : bVal - aVal;
        }
        
        if (aVal < bVal) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setFilteredSessions(results);
  }, [milkingSessions, searchTerm, sortConfig]);

  // Sort Handler
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Filter Handlers
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      session_type: "",
      operator_id: "",
      start_date: new Date().toISOString().split('T')[0],
      end_date: new Date().toISOString().split('T')[0]
    });
    setSearchTerm("");
    setSortConfig({ key: null, direction: 'asc' });
  };

  // Form Handlers
  const handleFormChange = (field, value) => {
    setMilkForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setMilkForm({
      animal_id: "",
      yield_liters: "",
      session_type: "Morning",
      quality_score: "",
      operator_id: "",
      specific_time: "",
      notes: "",
      date_time: new Date().toISOString().split('T')[0]
    });
    setActiveStep(0);
  };

  // Stepper Handlers
  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  // Create Milking Session
  const handleCreateMilkingSession = async () => {
    if (!milkForm.animal_id || !milkForm.yield_liters) {
      swal("Error", "Animal and milk yield are required", "error");
      return;
    }

    if (parseFloat(milkForm.yield_liters) <= 0) {
      swal("Error", "Milk yield must be greater than 0", "error");
      return;
    }

    try {
      const sessionData = {
        animal_id: parseInt(milkForm.animal_id),
        yield_liters: parseFloat(milkForm.yield_liters),
        session_type: milkForm.session_type,
        quality_score: milkForm.quality_score ? parseFloat(milkForm.quality_score) : null,
        specific_time: milkForm.specific_time || null,
        notes: milkForm.notes || "",
        date_time: milkForm.date_time,
      };

      if (milkForm.operator_id && parseInt(milkForm.operator_id) > 0) {
        const operatorExists = milkOperators.find(operator => operator.id === parseInt(milkForm.operator_id));
        if (operatorExists) {
          sessionData.operator_id = parseInt(milkForm.operator_id);
        } else {
          console.warn('Operator ID not found in milk operators list, setting to null');
        }
      }

      console.log('Sending session data:', sessionData);

      const res = await fetch(`${API_URL}/sessions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(sessionData),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Milking session recorded successfully!", "success");
        setOpenCreateDialog(false);
        resetForm();
        fetchMilkingSessions();
      } else {
        console.error('Server error:', data);
        swal("Error", data.error || "Failed to record session", "error");
      }
    } catch (err) {
      console.error('Error creating session:', err);
      swal("Error", "Something went wrong while recording the session", "error");
    }
  };

  // Update Milking Session
  const handleUpdateMilkingSession = async () => {
    if (!selectedSession) return;

    try {
      const sessionData = {
        animal_id: parseInt(milkForm.animal_id),
        yield_liters: parseFloat(milkForm.yield_liters),
        session_type: milkForm.session_type,
        quality_score: milkForm.quality_score ? parseFloat(milkForm.quality_score) : null,
        specific_time: milkForm.specific_time || null,
        notes: milkForm.notes || "",
        date_time: milkForm.date_time,
      };

      if (milkForm.operator_id && parseInt(milkForm.operator_id) > 0) {
        const operatorExists = milkOperators.find(operator => operator.id === parseInt(milkForm.operator_id));
        if (operatorExists) {
          sessionData.operator_id = parseInt(milkForm.operator_id);
        } else {
          console.warn('Operator ID not found in milk operators list, setting to null');
        }
      }

      console.log('Updating session data:', sessionData);

      const res = await fetch(`${API_URL}/sessions/${selectedSession.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(sessionData),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Milking session updated successfully!", "success");
        setOpenEditDialog(false);
        setSelectedSession(null);
        resetForm();
        fetchMilkingSessions();
      } else {
        console.error('Server error:', data);
        swal("Error", data.error || "Failed to update session", "error");
      }
    } catch (err) {
      console.error('Error updating session:', err);
      swal("Error", "Something went wrong while updating the session", "error");
    }
  };

  // Delete Handler
  const handleDelete = async (sessionId) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the milking session!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/sessions/${sessionId}`, { method: "DELETE" });
        const data = await res.json();
        if (res.ok) {
          swal("Deleted!", data.message, "success");
          fetchMilkingSessions();
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // View Handler
  const handleView = (session) => {
    setSelectedSession(session);
    setOpenViewDialog(true);
  };

  // Edit Handler
  const handleEdit = (session) => {
    setSelectedSession(session);
    setMilkForm({
      animal_id: session.animal_id.toString(),
      yield_liters: session.yield_liters.toString(),
      session_type: session.session_type,
      quality_score: session.quality_score ? session.quality_score.toString() : "",
      operator_id: session.operator_id ? session.operator_id.toString() : "",
      specific_time: session.specific_time || "",
      notes: session.notes || "",
      date_time: session.date_time.split('T')[0]
    });
    setOpenEditDialog(true);
  };

  // Generate Receipt
  const generateReceipt = (session) => {
    const receiptWindow = window.open("", "_blank");
    const receiptContent = `
      <html>
        <head>
          <title>Milk Production Receipt</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; border-bottom: 2px solid ${PRIMARY_COLOR}; padding-bottom: 10px; }
            .details { margin: 20px 0; }
            .detail-row { display: flex; justify-content: space-between; margin: 5px 0; }
            .footer { margin-top: 30px; text-align: center; font-size: 12px; color: #666; }
            .notes { margin-top: 15px; padding: 10px; background: #f5f5f5; border-radius: 5px; }
          </style>
        </head>
        <body>
          <div class="header">
            <h1 style="color: ${PRIMARY_COLOR};">🥛 Milk Production Receipt</h1>
            <p>Generated on: ${new Date().toLocaleDateString()}</p>
          </div>
          <div class="details">
            <div class="detail-row"><strong>Animal Tag:</strong> ${session.animal_tag}</div>
            <div class="detail-row"><strong>Animal Name:</strong> ${session.animal_name}</div>
            <div class="detail-row"><strong>Session Type:</strong> ${session.session_type}</div>
            <div class="detail-row"><strong>Milk Yield:</strong> ${session.yield_liters} Liters</div>
            <div class="detail-row"><strong>Quality Score:</strong> ${session.quality_score || 'N/A'}</div>
            <div class="detail-row"><strong>Operator:</strong> ${session.operator_name}</div>
            <div class="detail-row"><strong>Date & Time:</strong> ${session.display_date}</div>
            ${session.notes ? `
              <div class="notes">
                <strong>Notes:</strong><br>${session.notes}
              </div>
            ` : ''}
          </div>
          <div class="footer">
            <p>Generated on ${new Date().toLocaleString()}</p>
          </div>
        </body>
      </html>
    `;
    
    receiptWindow.document.write(receiptContent);
    receiptWindow.document.close();
    receiptWindow.print();
  };

  // Get Session Type Color
  const getSessionTypeColor = (sessionType) => {
    switch (sessionType) {
      case "Morning": return 'primary';
      case "Evening": return 'secondary';
      case "Regular": return 'success';
      case "Test": return 'warning';
      default: return 'default';
    }
  };

  // Get Quality Score Color
  const getQualityColor = (score) => {
    if (!score) return 'default';
    if (score >= 4.0) return 'success';
    if (score >= 3.0) return 'warning';
    return 'error';
  };

  // Virtualized Table Content
  const fixedHeaderContent = () => (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="left"
          style={{ width: column.width }}
          sx={{ 
            backgroundColor: PRIMARY_COLOR, 
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '12px 8px'
          }}
        >
          <TableSortLabel
            active={sortConfig.key === column.dataKey}
            direction={sortConfig.direction}
            onClick={() => handleSort(column.dataKey)}
            sx={{ color: 'white !important' }}
          >
            {column.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  );

  const rowContent = (index, session) => (
    <React.Fragment>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {session.display_date}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {session.animal_tag}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {session.animal_name}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={session.session_type} 
          size="small"
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            backgroundColor: 
              session.session_type === "Morning" ? PRIMARY_COLOR :
              session.session_type === "Evening" ? SECONDARY_COLOR :
              session.session_type === "Regular" ? '#4caf50' : '#ff9800',
            color: 'white'
          }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" sx={{ color: PRIMARY_COLOR }} noWrap>
          {session.yield_liters} L
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        {session.quality_score ? (
          <Chip 
            label={session.quality_score} 
            size="small"
            sx={{ 
              fontSize: '0.7rem', 
              height: '24px',
              backgroundColor: 
                session.quality_score >= 4.0 ? '#4caf50' :
                session.quality_score >= 3.0 ? '#ff9800' : '#f44336',
              color: 'white'
            }}
          />
        ) : (
          <Typography variant="body2" color="textSecondary" noWrap>
            N/A
          </Typography>
        )}
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap title={session.operator_name}>
          {session.operator_name}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
          <IconButton 
            size="small" 
            onClick={() => handleView(session)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: PRIMARY_COLOR
            }}
          >
            <ViewIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleEdit(session)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: PRIMARY_LIGHT
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => generateReceipt(session)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: SECONDARY_COLOR
            }}
          >
            <ReceiptIcon fontSize="small" />
          </IconButton>
          {session.notes && (
            <IconButton 
              size="small" 
              onClick={() => swal("Session Notes", session.notes || "No notes available", "info")}
              sx={{ 
                minWidth: '32px', 
                width: '32px', 
                height: '32px',
                color: '#ff9800'
              }}
            >
              <NoteIcon fontSize="small" />
            </IconButton>
          )}
          <IconButton 
            size="small" 
            onClick={() => handleDelete(session.id)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: '#d32f2f'
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </TableCell>
    </React.Fragment>
  );

  // Stepper Content
  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Box>
            <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
              Select Animal
            </Typography>
            <FormControl fullWidth size="large" sx={{ mb: 3 }}>
              <InputLabel id="animal-label">Select Animal *</InputLabel>
              <Select
                labelId="animal-label"
                value={milkForm.animal_id}
                onChange={(e) => handleFormChange('animal_id', e.target.value)}
                label="Select Animal *"
                disabled={milkingCows.length === 0}
              >
                {milkingCows.map(cow => (
                  <MenuItem key={cow.id} value={cow.id.toString()}>
                    <Box>
                      <Typography variant="body1" fontWeight="bold">
                        {cow.tag_number} - {cow.name || 'Unnamed'}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {cow.breed} • ID: {cow.id}
                      </Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                Choose the cow that was milked (required)
              </FormHelperText>
            </FormControl>
          </Box>
        );
      
      case 1:
        return (
          <Box>
            <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
              Session Details
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  size="large"
                  label="Milk Yield (Liters) *"
                  type="number"
                  step="0.1"
                  value={milkForm.yield_liters}
                  onChange={(e) => handleFormChange('yield_liters', e.target.value)}
                  placeholder="Enter amount in liters"
                  required
                  sx={{ mb: 3 }}
                  helperText="Total milk collected in liters (required)"
                />

                <FormControl fullWidth size="large" sx={{ mb: 3 }}>
                  <InputLabel id="session-type-label">Session Type</InputLabel>
                  <Select
                    labelId="session-type-label"
                    value={milkForm.session_type}
                    onChange={(e) => handleFormChange('session_type', e.target.value)}
                    label="Session Type"
                  >
                    {sessionTypes.map(type => (
                      <MenuItem key={type} value={type}>
                        {type} Session
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    Type of milking session
                  </FormHelperText>
                </FormControl>

                <TextField
                  fullWidth
                  size="large"
                  label="Quality Score (Butterfat %)"
                  type="number"
                  step="0.1"
                  value={milkForm.quality_score}
                  onChange={(e) => handleFormChange('quality_score', e.target.value)}
                  placeholder="Optional butterfat percentage"
                  sx={{ mb: 3 }}
                  helperText="Milk quality measurement (optional)"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="large" sx={{ mb: 3 }}>
                  <InputLabel id="operator-label">Select Operator</InputLabel>
                  <Select
                    labelId="operator-label"
                    value={milkForm.operator_id}
                    onChange={(e) => handleFormChange('operator_id', e.target.value)}
                    label="Select Operator"
                  >
                    <MenuItem value="">
                      <em>Not specified</em>
                    </MenuItem>
                    {milkOperators.map(operator => (
                      <MenuItem key={operator.id} value={operator.id.toString()}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <PersonIcon fontSize="small" />
                          <Box>
                            <Typography variant="body1">
                              {operator.first_name} {operator.last_name}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                              {operator.job_title || 'Milker'} • ID: {operator.id}
                            </Typography>
                          </Box>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {milkOperators.length === 0 ? 
                      "No milk operators found. Please add employees with milker roles first." : 
                      "Person who performed the milking (optional)"
                    }
                  </FormHelperText>
                </FormControl>

                <TextField
                  fullWidth
                  size="large"
                  label="Specific Time"
                  type="time"
                  value={milkForm.specific_time}
                  onChange={(e) => handleFormChange('specific_time', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ mb: 3 }}
                  helperText="Time when milking occurred"
                />

                <TextField
                  fullWidth
                  size="large"
                  label="Session Date"
                  type="date"
                  value={milkForm.date_time}
                  onChange={(e) => handleFormChange('date_time', e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ mb: 3 }}
                  helperText="Date when milking occurred"
                />
              </Grid>
            </Grid>
          </Box>
        );
      
      case 2:
        return (
          <Box>
            <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
              Review & Notes
            </Typography>
            <Card variant="outlined" sx={{ mb: 3, p: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Session Summary
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body2" color="textSecondary">Animal:</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {milkingCows.find(c => c.id === parseInt(milkForm.animal_id))?.tag_number || 'Not selected'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="textSecondary">Yield:</Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ color: PRIMARY_COLOR }}>
                    {milkForm.yield_liters} Liters
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="textSecondary">Session Type:</Typography>
                  <Chip 
                    label={milkForm.session_type} 
                    size="small"
                    sx={{ 
                      backgroundColor: 
                        milkForm.session_type === "Morning" ? PRIMARY_COLOR :
                        milkForm.session_type === "Evening" ? SECONDARY_COLOR :
                        milkForm.session_type === "Regular" ? '#4caf50' : '#ff9800',
                      color: 'white'
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body2" color="textSecondary">Operator:</Typography>
                  <Typography variant="body1">
                    {milkOperators.find(o => o.id === parseInt(milkForm.operator_id)) ? 
                      `${milkOperators.find(o => o.id === parseInt(milkForm.operator_id)).first_name} ${milkOperators.find(o => o.id === parseInt(milkForm.operator_id)).last_name}` : 
                      'Not specified'
                    }
                  </Typography>
                </Grid>
              </Grid>
            </Card>

            <TextField
              fullWidth
              multiline
              rows={4}
              label="Session Notes"
              placeholder="Add any observations, comments, or special notes about this milking session..."
              value={milkForm.notes}
              onChange={(e) => handleFormChange('notes', e.target.value)}
              helperText="Optional notes about the milking session"
            />
          </Box>
        );
      
      default:
        return 'Unknown step';
    }
  };

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: PRIMARY_COLOR }}>
        <Toolbar>
          <MilkIcon sx={{ mr: 2 }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Milk Production
          </Typography>
          <Chip 
            label={`${milkingSessions.length} Sessions`} 
            sx={{ 
              backgroundColor: SECONDARY_COLOR, 
              color: 'white', 
              fontWeight: 'bold', 
              mr: 2 
            }}
          />
          <Button 
            variant="contained" 
            startIcon={<AddIcon />}
            onClick={() => setOpenCreateDialog(true)}
            sx={{ 
              borderRadius: 2, 
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400',
                transform: 'translateY(-2px)',
                boxShadow: 4
              },
              transition: 'all 0.3s ease',
              fontWeight: 'bold',
              fontSize: '1rem',
              px: 3,
              py: 1
            }}
          >
            New Session
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Paper sx={{ borderRadius: 2, border: 2, borderColor: PRIMARY_LIGHT, overflow: 'hidden' }}>
          {/* Search and Filters Header */}
          <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider', backgroundColor: 'background.paper' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  placeholder="Search by cow tag, name, session type, operator..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
                  }}
                  size="medium"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <Button
                    startIcon={<FilterIcon />}
                    onClick={() => setShowFilters(!showFilters)}
                    variant={showFilters ? "contained" : "outlined"}
                    size="medium"
                    sx={{
                      backgroundColor: showFilters ? PRIMARY_COLOR : 'transparent',
                      color: showFilters ? 'white' : PRIMARY_COLOR,
                      borderColor: PRIMARY_COLOR,
                      '&:hover': {
                        backgroundColor: showFilters ? PRIMARY_DARK : 'rgba(2, 74, 89, 0.04)',
                        borderColor: PRIMARY_DARK,
                      }
                    }}
                  >
                    Filters
                  </Button>
                  <Button 
                    onClick={resetFilters} 
                    variant="outlined" 
                    size="medium" 
                    sx={{
                      color: PRIMARY_COLOR,
                      borderColor: PRIMARY_COLOR,
                      '&:hover': {
                        borderColor: PRIMARY_DARK,
                        backgroundColor: 'rgba(2, 74, 89, 0.04)',
                      }
                    }}
                  >
                    Reset
                  </Button>
                  <Button 
                    onClick={fetchMilkingSessions} 
                    variant="contained" 
                    size="medium" 
                    sx={{
                      backgroundColor: SECONDARY_COLOR,
                      '&:hover': {
                        backgroundColor: '#e59400'
                      }
                    }}
                  >
                    Refresh
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Expandable Filters */}
            {showFilters && (
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="medium">
                      <InputLabel>Session Type</InputLabel>
                      <Select
                        value={filters.session_type}
                        onChange={(e) => handleFilterChange('session_type', e.target.value)}
                        label="Session Type"
                      >
                        <MenuItem value="">All Types</MenuItem>
                        {sessionTypes.map(type => (
                          <MenuItem key={type} value={type}>{type}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="medium">
                      <InputLabel>Operator</InputLabel>
                      <Select
                        value={filters.operator_id}
                        onChange={(e) => handleFilterChange('operator_id', e.target.value)}
                        label="Operator"
                      >
                        <MenuItem value="">All Operators</MenuItem>
                        {milkOperators.map(operator => (
                          <MenuItem key={operator.id} value={operator.id.toString()}>
                            {operator.first_name} {operator.last_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      size="medium"
                      label="Start Date"
                      type="date"
                      value={filters.start_date}
                      onChange={(e) => handleFilterChange('start_date', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      size="medium"
                      label="End Date"
                      type="date"
                      value={filters.end_date}
                      onChange={(e) => handleFilterChange('end_date', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

          {/* Sessions Table */}
          <Box sx={{ p: 2 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress sx={{ color: PRIMARY_COLOR }} />
              </Box>
            ) : filteredSessions.length === 0 ? (
              <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: PRIMARY_LIGHT }}>
                <CardContent>
                  <AgricultureIcon sx={{ fontSize: 64, color: PRIMARY_COLOR, mb: 2 }} />
                  <Typography variant="h5" sx={{ color: PRIMARY_COLOR }} gutterBottom>
                    No milking sessions found
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    {searchTerm || Object.values(filters).some(v => v) 
                      ? "Try adjusting your search or filters" 
                      : "Record your first milking session to track milk production"
                    }
                  </Typography>
                  <Button 
                    variant="contained" 
                    onClick={() => setOpenCreateDialog(true)} 
                    size="large"
                    startIcon={<AddIcon />}
                    sx={{ 
                      borderRadius: 2,
                      backgroundColor: SECONDARY_COLOR,
                      '&:hover': {
                        backgroundColor: '#e59400'
                      }
                    }}
                  >
                    Record First Session
                  </Button>
                </CardContent>
              </Card>
            ) : (
              <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: PRIMARY_LIGHT, borderRadius: 1 }}>
                <TableVirtuoso
                  data={filteredSessions}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </Paper>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Create Milking Session Dialog with Stepper */}
      <Dialog 
        open={openCreateDialog} 
        onClose={() => {
          setOpenCreateDialog(false);
          resetForm();
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ backgroundColor: PRIMARY_COLOR, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <AddIcon sx={{ mr: 1 }} />
              <Typography variant="h6">Record New Milking Session</Typography>
            </Box>
            <IconButton 
              onClick={() => {
                setOpenCreateDialog(false);
                resetForm();
              }} 
              sx={{ color: 'white' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 4 }}>
          {/* Stepper */}
          <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* Step Content */}
          {getStepContent(activeStep)}

          {milkingCows.length === 0 && (
            <Alert severity="warning" sx={{ mt: 2 }}>
              No cows available for milking. Please add animals first.
            </Alert>
          )}

          {milkOperators.length === 0 && (
            <Alert severity="info" sx={{ mt: 2 }}>
              No milk operators found. Please add employees with milker roles to assign operators.
            </Alert>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 3, justifyContent: 'space-between' }}>
          <Button 
            onClick={handleBack} 
            disabled={activeStep === 0}
            sx={{ minWidth: 100 }}
          >
            Back
          </Button>
          
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button 
              onClick={() => {
                setOpenCreateDialog(false);
                resetForm();
              }} 
              sx={{ minWidth: 100 }}
            >
              Cancel
            </Button>
            
            {activeStep === steps.length - 1 ? (
              <Button 
                onClick={handleCreateMilkingSession} 
                variant="contained" 
                disabled={!milkForm.animal_id || !milkForm.yield_liters}
                sx={{ 
                  minWidth: 150,
                  backgroundColor: SECONDARY_COLOR,
                  '&:hover': {
                    backgroundColor: '#e59400'
                  }
                }}
              >
                Record Session
              </Button>
            ) : (
              <Button 
                onClick={handleNext} 
                variant="contained"
                disabled={activeStep === 0 && !milkForm.animal_id}
                sx={{ 
                  minWidth: 100,
                  backgroundColor: PRIMARY_COLOR,
                  '&:hover': {
                    backgroundColor: PRIMARY_DARK
                  }
                }}
              >
                Next
              </Button>
            )}
          </Box>
        </DialogActions>
      </Dialog>

      {/* Edit Milking Session Dialog */}
      <Dialog 
        open={openEditDialog} 
        onClose={() => setOpenEditDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ backgroundColor: PRIMARY_COLOR, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <EditIcon sx={{ mr: 1 }} />
            <Typography variant="h6">Edit Milking Session</Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="large" sx={{ mb: 3 }}>
                <InputLabel id="edit-animal-label">Select Animal *</InputLabel>
                <Select
                  labelId="edit-animal-label"
                  value={milkForm.animal_id}
                  onChange={(e) => handleFormChange('animal_id', e.target.value)}
                  label="Select Animal *"
                >
                  {milkingCows.map(cow => (
                    <MenuItem key={cow.id} value={cow.id.toString()}>
                      <Box>
                        <Typography variant="body1" fontWeight="bold">
                          {cow.tag_number} - {cow.name || 'Unnamed'}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {cow.breed} • ID: {cow.id}
                        </Typography>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  Choose the cow that was milked (required)
                </FormHelperText>
              </FormControl>

              <FormControl fullWidth size="large" sx={{ mb: 3 }}>
                <InputLabel id="edit-operator-label">Select Operator</InputLabel>
                <Select
                  labelId="edit-operator-label"
                  value={milkForm.operator_id}
                  onChange={(e) => handleFormChange('operator_id', e.target.value)}
                  label="Select Operator"
                >
                  <MenuItem value="">
                    <em>Not specified</em>
                  </MenuItem>
                  {milkOperators.map(operator => (
                    <MenuItem key={operator.id} value={operator.id.toString()}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <PersonIcon fontSize="small" />
                        <Box>
                          <Typography variant="body1">
                            {operator.first_name} {operator.last_name}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {operator.job_title || 'Milker'} • ID: {operator.id}
                          </Typography>
                        </Box>
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  Person who performed the milking (optional)
                </FormHelperText>
              </FormControl>

              <FormControl fullWidth size="large" sx={{ mb: 3 }}>
                <InputLabel id="edit-session-type-label">Session Type</InputLabel>
                <Select
                  labelId="edit-session-type-label"
                  value={milkForm.session_type}
                  onChange={(e) => handleFormChange('session_type', e.target.value)}
                  label="Session Type"
                >
                  {sessionTypes.map(type => (
                    <MenuItem key={type} value={type}>
                      {type} Session
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  Type of milking session
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="large"
                label="Milk Yield (Liters) *"
                type="number"
                step="0.1"
                value={milkForm.yield_liters}
                onChange={(e) => handleFormChange('yield_liters', e.target.value)}
                placeholder="Enter amount in liters"
                required
                sx={{ mb: 3 }}
                helperText="Total milk collected in liters (required)"
              />

              <TextField
                fullWidth
                size="large"
                label="Quality Score (Butterfat %)"
                type="number"
                step="0.1"
                value={milkForm.quality_score}
                onChange={(e) => handleFormChange('quality_score', e.target.value)}
                placeholder="Optional butterfat percentage"
                sx={{ mb: 3 }}
                helperText="Milk quality measurement (optional)"
              />

              <TextField
                fullWidth
                size="large"
                label="Specific Time"
                type="time"
                value={milkForm.specific_time}
                onChange={(e) => handleFormChange('specific_time', e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 3 }}
                helperText="Time when milking occurred"
              />

              <TextField
                fullWidth
                size="large"
                label="Session Date"
                type="date"
                value={milkForm.date_time}
                onChange={(e) => handleFormChange('date_time', e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 3 }}
                helperText="Date when milking occurred"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={4}
                label="Session Notes"
                placeholder="Add any observations, comments, or special notes about this milking session..."
                value={milkForm.notes}
                onChange={(e) => handleFormChange('notes', e.target.value)}
                helperText="Optional notes about the milking session"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button 
            onClick={() => setOpenEditDialog(false)} 
            size="large"
            sx={{ minWidth: 120 }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleUpdateMilkingSession} 
            variant="contained" 
            size="large"
            disabled={!milkForm.animal_id || !milkForm.yield_liters}
            sx={{ 
              minWidth: 200,
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400'
              }
            }}
          >
            Update Session
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Session Dialog */}
      <Dialog 
        open={openViewDialog} 
        onClose={() => setOpenViewDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ViewIcon sx={{ mr: 1 }} />
              Milking Session Details
            </Box>
            <IconButton onClick={() => setOpenViewDialog(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedSession && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Animal Information
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Animal Tag:</strong> {selectedSession.animal_tag}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Animal Name:</strong> {selectedSession.animal_name}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Session Details
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Date & Time:</strong> {selectedSession.display_date}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Session Type:</strong> 
                      <Chip 
                        label={selectedSession.session_type} 
                        size="small"
                        sx={{ 
                          ml: 1,
                          backgroundColor: 
                            selectedSession.session_type === "Morning" ? PRIMARY_COLOR :
                            selectedSession.session_type === "Evening" ? SECONDARY_COLOR :
                            selectedSession.session_type === "Regular" ? '#4caf50' : '#ff9800',
                          color: 'white'
                        }}
                      />
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Production Data
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Milk Yield:</strong> {selectedSession.yield_liters} Liters
                    </Typography>
                    <Typography variant="body2">
                      <strong>Quality Score:</strong> 
                      {selectedSession.quality_score ? (
                        <Chip 
                          label={selectedSession.quality_score} 
                          size="small"
                          sx={{ 
                            ml: 1,
                            backgroundColor: 
                              selectedSession.quality_score >= 4.0 ? '#4caf50' :
                              selectedSession.quality_score >= 3.0 ? '#ff9800' : '#f44336',
                            color: 'white'
                          }}
                        />
                      ) : 'N/A'}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Operator Information
                    </Typography>
                    <Typography variant="body2">
                      <strong>Operator:</strong> {selectedSession.operator_name}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              {selectedSession.notes && (
                <Grid item xs={12}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                        Session Notes
                      </Typography>
                      <Typography variant="body2">
                        {selectedSession.notes}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
          <Button 
            onClick={() => generateReceipt(selectedSession)} 
            variant="contained" 
            startIcon={<ReceiptIcon />}
            sx={{
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400'
              }
            }}
          >
            Generate Receipt
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MilkProductionPage;

